
<template>
    <div>
         <modal @modal_hide="modal_hide" ref="detail" :size="'modal-lg'" :footer = false>
            <template v-slot:header>{{title}}</template>
            <template v-slot:body>
            
                <div class="w-100 text-center">
                    <img  v-if="type==2" class="card-img-top img-fluid mb-1" style="height:auto; max-width: 560px; width: 100%;" :src="preview"> 
                    <youtube  v-if="type==1" :video-id="preview" :width="'100%'" :resize="true"></youtube>
                </div>
                
                <div mt-2 text-center >
                    {{description}}
                </div>
                
                <div v-if="documents.length>0" class=" mt-2 mb-1"><h4>{{$t('message.documents')}}</h4></div>
                <div class="list-group list-group-flush">
                    <a v-for='item in documents' :key="item.id"  class="list-group-item list-group-item-action border-0 d-flex" :href="item.link" >
                        <div class="list-icon">
                            <i class="badge-circle badge-circle-light-secondary mr-1 "><font-awesome-icon :icon="['fas', 'file']"/></i>
                        </div>
                        <div class="list-content">
                            <h5>{{item.name}}</h5>
                             <small>{{item.description}}</small>
                            
                        </div>
                    </a>
                </div>
            </template>
        </modal>
    </div> 
</template>

<script>
    import Vue from 'vue'
    import VueYoutube from 'vue-youtube'
    Vue.use(VueYoutube)
    import globalSettings from '@/config.js'
    import modal from '@/components/modal'
    import axios from 'axios';
    export default{
        name: 'academy_form',
        props:['id'],
        
        watch: {
            id: function (val) {
                if(val){
                    this.getData(val)
                }
            }
        
      },
      components:{
        modal
      },
        data() {
            return{
                title:null,
                type:null,
                preview:null,
                description:null,
                documents:[]
            }
        },

        
        methods: {
           
           modal_hide: function(){
                    this.$emit('clear')
              }, 
           getData: function(id){
            this.loaded = false
             axios.get(globalSettings.api_url + 'academy/'+id+'/details')
            .then(response => {
                this.preview = response.data.preview,
                this.title =  response.data.title
                this.type =  response.data.type
                this.link =  response.data.link
                 this.description =  response.data.description
                 this.documents = response.data.documents
               
                this.$refs.detail.show()
                this.id=null
 
            })
            .catch(error => {
               console.log(error)
            })         
      }, 
            
        }
    }
</script>

  
            

            